import { Controller } from "@hotwired/stimulus"

// Client-side status filter for the Communications hub message history.
// Shows/hides rows (each carries data-status) to match the selected status.
export default class extends Controller {
  static targets = ["row"]

  filter(event) {
    const status = event.target.value
    this.rowTargets.forEach((row) => {
      const match = status === "all" || row.dataset.status === status
      row.classList.toggle("d-none", !match)
    })
  }
}
